import React from 'react';

function Footer() {
  return (
    <footer>
      <p>&copy; 2025 Indosam Cricket Club. All rights reserved.</p>
    </footer>
  );
}

export default Footer;